import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';
import { showToast } from '../../utils/toast';
import { handleErrors, isObject } from '../../utils/common';

const HomeCMS = () => {
    const { code } = useParams();
    const formRef = useRef();

    const [formData, setFormData] = useState({
        section_two_heading: "",
        section_two_sub_heading: "",
        section_two_description: "",
        section_two_cta_text: "",
        section_two_cta_link: "",
        section_three_heading: "",
        section_three_sub_heading: "",
        section_four_heading: "",
        section_four_sub_heading: "",
        section_five_heading: "",
        section_five_sub_heading: "",
        section_six_heading: "",
        section_six_sub_heading: "",
        section_six_paragraph: "",
        section_seven_heading: "",
        section_seven_sub_heading: "",
        section_seven_paragraph: "",
        section_nine_heading: "",
        section_nine_sub_heading: "",
        section_nine_cta_text: "",
        section_nine_cta_link: ""
    });

    const [images, setImages] = useState({
        section_two_background_img: null,
        section_three_background_img: null,
        section_four_background_img: null,
        section_five_background_img: null,
        section_five_banner_img: null,
        section_six_background_img: null,
        section_seven_background_img: null,
        section_nine_background_img: null,
        section_nine_background_video: null
    });

    const [imagePreviews, setImagePreviews] = useState({
        section_two_background_img: null,
        section_three_background_img: null,
        section_four_background_img: null,
        section_five_background_img: null,
        section_five_banner_img: null,
        section_six_background_img: null,
        section_seven_background_img: null,
        section_nine_background_img: null,
        section_nine_background_video: null
    });

    const [baseUrl, setBaseUrl] = useState('');
    const [sectionOneRepeater, setSectionOneRepeater] = useState([]);
    const [sectionTwoRepeater, setSectionTwoRepeater] = useState([]);
    const [sectionFiveRepeater, setSectionFiveRepeater] = useState([]);
    const [sectionSevenRepeater, setSectionSevenRepeater] = useState([]);
    const [sectionEightRepeater, setSectionEightRepeater] = useState([]);

    const [submitting, setSubmitting] = useState(false);

    const [rawMode, setRawMode] = useState({});
    const toggleRawMode = (field) =>
        setRawMode(prev => ({ ...prev, [field]: !prev[field] }));


    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            setImages(prev => ({ ...prev, [field]: file }));
            setImagePreviews(prev => ({ ...prev, [field]: URL.createObjectURL(file) }));
        }
    };

    const handleRepeaterChange = (setter) => (index, field, value) => {
        setter(prev => {
            const newArr = [...prev];
            newArr[index][field] = value;
            return newArr;
        });
    };

    const handleAddRepeater = (setter, emptyObj) => () => {
        setter(prev => [...prev, emptyObj]);
    };

    const handleRemoveRepeater = (setter) => (index) => {
        setter(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        const fetchCMS = async () => {
            try {
                const res = await api.get(`/cms/${code}`);
                if (res.status === 200) {
                    const data = res.data.cms;
                    setBaseUrl(res.data.base_url || '');
                    setFormData({
                        section_two_heading: data.section_two_heading || "",
                        section_two_sub_heading: data.section_two_sub_heading || "",
                        section_two_description: data.section_two_description || "",
                        section_two_cta_text: data.section_two_cta_text || "",
                        section_two_cta_link: data.section_two_cta_link || "",
                        section_three_heading: data.section_three_heading || "",
                        section_three_sub_heading: data.section_three_sub_heading || "",
                        section_four_heading: data.section_four_heading || "",
                        section_four_sub_heading: data.section_four_sub_heading || "",
                        section_five_heading: data.section_five_heading || "",
                        section_five_sub_heading: data.section_five_sub_heading || "",
                        section_six_heading: data.section_six_heading || "",
                        section_six_sub_heading: data.section_six_sub_heading || "",
                        section_six_paragraph: data.section_six_paragraph || "",
                        section_seven_heading: data.section_seven_heading || "",
                        section_seven_sub_heading: data.section_seven_sub_heading || "",
                        section_seven_paragraph: data.section_seven_paragraph || "",
                        section_nine_heading: data.section_nine_heading || "",
                        section_nine_sub_heading: data.section_nine_sub_heading || "",
                        section_nine_cta_text: data.section_nine_cta_text || "",
                        section_nine_cta_link: data.section_nine_cta_link || ""
                    });

                    setImagePreviews({
                        section_two_background_img: data.section_two_background_img ? `${res.data.base_url}${data.section_two_background_img}` : null,
                        section_three_background_img: data.section_three_background_img ? `${res.data.base_url}${data.section_three_background_img}` : null,
                        section_four_background_img: data.section_four_background_img ? `${res.data.base_url}${data.section_four_background_img}` : null,
                        section_five_background_img: data.section_five_background_img ? `${res.data.base_url}${data.section_five_background_img}` : null,
                        section_five_banner_img: data.section_five_banner_img ? `${res.data.base_url}${data.section_five_banner_img}` : null,
                        section_six_background_img: data.section_six_background_img ? `${res.data.base_url}${data.section_six_background_img}` : null,
                        section_seven_background_img: data.section_seven_background_img ? `${res.data.base_url}${data.section_seven_background_img}` : null,
                        section_nine_background_img: data.section_nine_background_img ? `${res.data.base_url}${data.section_nine_background_img}` : null,
                        section_nine_background_video: data.section_nine_background_video ? `${res.data.base_url}${data.section_nine_background_video}` : null,
                    });

                    setSectionOneRepeater(data.section_one_repeater || []);
                    setSectionTwoRepeater(data.section_two_button_repeater || []);
                    setSectionFiveRepeater(data.section_five_repeater || []);
                    setSectionSevenRepeater(data.section_seven_repeater || []);
                    setSectionEightRepeater(data.section_eight_repeater || []);
                }
            } catch (err) {
                handleErrors(err);
            }
        };

        fetchCMS();

        $.validator.addMethod('ckeditorRequired', function (value) {
            const textOnly = value.replace(/<[^>]*>/g, '').trim();
            return textOnly.length > 0;
        }, 'This field is required');


        if (formRef.current && window.$.fn.validate) {
            window.$(formRef.current).validate({
                rules: {
                    section_two_paragraph: { ckeditorRequired: true },
                    section_six_heading: { required: true },
                    section_six_paragraph: { ckeditorRequired: true },
                    section_seven_heading: { required: true },
                    section_seven_paragraph: { ckeditorRequired: true }
                },
                errorElement: "label",
                validClass: "is-valid",
                errorClass: "is-invalid text-danger",
                highlight: function (element, errorClass, validClass) {
                    window.$(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    window.$(element).removeClass(errorClass).addClass(validClass);
                }
            });
        }
    }, [code]);

    const handleFormSubmit = async () => {
        const $ = window.jQuery;
        const form = $(formRef.current);

        if (form.valid()) {
            const data = new FormData();
            Object.entries(formData).forEach(([key, value]) => data.append(key, value));

            Object.entries(images).forEach(([key, file]) => {
                if (file) data.append(key, file);
            });

            // Helper: strip File objects from a repeater, append them separately as
            // indexed multipart fields (e.g. "section_one_repeater[0][background_img]")
            // so multer can process them while the JSON string stays serialisable.
            const appendRepeater = (fieldName, repeater, fileFields = []) => {
                const sanitised = repeater.map((item, index) => {
                    const copy = { ...item };
                    fileFields.forEach(ff => {
                        if (copy[ff] instanceof File) {
                            data.append(`${fieldName}[${index}][${ff}]`, copy[ff]);
                            delete copy[ff]; // remove from JSON — backend will inject multer file
                        }
                    });
                    return copy;
                });
                data.append(fieldName, JSON.stringify(sanitised));
            };

            appendRepeater("section_one_repeater", sectionOneRepeater, ["background_img"]);
            data.append("section_two_button_repeater", JSON.stringify(sectionTwoRepeater));
            data.append("section_five_repeater", JSON.stringify(sectionFiveRepeater));
            data.append("section_seven_repeater", JSON.stringify(sectionSevenRepeater));
            data.append("section_eight_repeater", JSON.stringify(sectionEightRepeater));

            try {
                setSubmitting(true);
                const res = await api.put(`/cms/${code}`, data, {
                    headers: { "Content-Type": "multipart/form-data" }
                });
                showToast("success", res.data.message, "Success");
            } catch (err) {
                handleErrors(err);
            } finally {
                setSubmitting(false);
            }
        }
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.ROOT}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={`/cms/home`}>Home Page</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Home Page</h4>
                        </div>
                        <div className="card-body">
                            <form ref={formRef} noValidate>
                                <div className="row">
                                    {/* Section 1 */}
                                    <div className="col-12"><h5 className="mb-3">Section One</h5></div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-bold">Section One Repeater</label>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Heading</th>
                                                        <th>Sub Heading</th>
                                                        <th>Button Text</th>
                                                        <th>Button Link</th>
                                                        <th>Background Image</th>
                                                        <th width="10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sectionOneRepeater.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Heading"
                                                                    value={item.heading || ''}
                                                                    onChange={(e) => handleRepeaterChange(setSectionOneRepeater)(index, 'heading', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Sub Heading"
                                                                    value={item.sub_heading || ''}
                                                                    onChange={(e) => handleRepeaterChange(setSectionOneRepeater)(index, 'sub_heading', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Button Text"
                                                                    value={item.button_left_text || ''}
                                                                    onChange={(e) => handleRepeaterChange(setSectionOneRepeater)(index, 'button_left_text', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Button Link"
                                                                    value={item.button_left_link || ''}
                                                                    onChange={(e) => handleRepeaterChange(setSectionOneRepeater)(index, 'button_left_link', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <input
                                                                        type="file"
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Image filename or URL"
                                                                        onChange={(e) => handleRepeaterChange(setSectionOneRepeater)(index, 'background_img', e.target.files[0])}
                                                                    />
                                                                    {isObject(item.background_img) && (
                                                                        <img
                                                                            src={URL.createObjectURL(item.background_img)}
                                                                            alt="Preview"
                                                                            style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                                                                            className="ms-2 rounded border flex-shrink-0"
                                                                            onError={(e) => { e.target.style.display = 'none'; }}
                                                                        />
                                                                    )}
                                                                    {item.background_img && !isObject(item.background_img) && (
                                                                        <img
                                                                            src={baseUrl + item.background_img}
                                                                            alt="Preview"
                                                                            style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                                                                            className="ms-2 rounded border flex-shrink-0"
                                                                            onError={(e) => { e.target.style.display = 'none'; }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-danger px-3 py-1"
                                                                    onClick={() => handleRemoveRepeater(setSectionOneRepeater)(index)}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-light"
                                            onClick={handleAddRepeater(setSectionOneRepeater, {
                                                heading: '',
                                                sub_heading: '',
                                                button_left_text: '',
                                                button_left_link: '',
                                                background_img: ''
                                            })}
                                        >
                                            <i className="fa fa-plus"></i> Add Item
                                        </button>
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 2 */}
                                    <div className="col-12"><h5 className="mb-3">Section Two: Why Choose Us</h5></div>
                                    {[
                                        { name: 'section_two_heading', label: 'Heading' },
                                        { name: 'section_two_sub_heading', label: 'Sub Heading' },
                                        { name: 'section_two_cta_text', label: 'CTA Text' },
                                        { name: 'section_two_cta_link', label: 'CTA Link' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-3 col-md-6" key={name}>
                                            <label className="form-label">{label}</label>
                                            <input type="text" className="form-control" name={name} value={formData[name]} onChange={handleChange} />
                                        </div>
                                    ))}


                                    <div className="mb-3 col-12">
                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                            <label className="form-label mb-0">Paragraph</label>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => toggleRawMode('section_two_description')}
                                            >
                                                {rawMode['section_two_description'] ? '⬅ Rich Editor' : '</> Raw HTML'}
                                            </button>
                                        </div>
                                        {rawMode['section_two_description'] ? (
                                            <textarea
                                                className="form-control font-monospace"
                                                rows={8}
                                                value={formData.section_two_description}
                                                onChange={e =>
                                                    setFormData(prev => ({ ...prev, section_two_description: e.target.value }))
                                                }
                                            />
                                        ) : (
                                            <CKEditor
                                                editor={ClassicEditor}
                                                config={{
                                                    toolbar: [
                                                        'heading', '|',
                                                        'bold', 'italic', 'link', 'code', 'codeBlock',
                                                        '|', 'bulletedList', 'numberedList'
                                                    ]
                                                }}
                                                data={formData.section_two_description}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setFormData(prev => ({ ...prev, section_two_description: data }));
                                                    const hiddenInput = document.querySelector('input[name="section_two_description"]');
                                                    if (hiddenInput) hiddenInput.value = data;
                                                }}
                                            />
                                        )}
                                        <input
                                            type="hidden"
                                            name="section_two_description"
                                            value={formData.section_two_description}
                                        />
                                    </div>


                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Image</label>
                                        <input type="file" className="form-control" onChange={(e) => handleImageChange(e, 'section_two_background_img')} />
                                        {imagePreviews.section_two_background_img && (
                                            <img src={imagePreviews.section_two_background_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-bold">Buttons Repeater</label>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Key</th>
                                                        <th>Value</th>
                                                        <th width="10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sectionTwoRepeater.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.key} onChange={(e) => handleRepeaterChange(setSectionTwoRepeater)(index, 'key', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.value} onChange={(e) => handleRepeaterChange(setSectionTwoRepeater)(index, 'value', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <button type="button" className="btn btn-sm btn-danger px-3 py-1" onClick={() => handleRemoveRepeater(setSectionTwoRepeater)(index)}><i className="fa fa-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <button type="button" className="btn btn-sm btn-light" onClick={handleAddRepeater(setSectionTwoRepeater, { key: '', value: '' })}><i className="fa fa-plus"></i> Add Button Item</button>
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 3 */}
                                    <div className="col-12"><h5 className="mb-3">Section Three: Featured Listings</h5></div>
                                    {[
                                        { name: 'section_three_heading', label: 'Heading' },
                                        { name: 'section_three_sub_heading', label: 'Sub Heading' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-6 col-md-6" key={name}>
                                            <label className="form-label">{label}</label>
                                            <input type="text" className="form-control" name={name} value={formData[name]} onChange={handleChange} />
                                        </div>
                                    ))}
                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Image</label>
                                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e, 'section_three_background_img')} />
                                        {imagePreviews.section_three_background_img && (
                                            <img src={imagePreviews.section_three_background_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 4 */}
                                    <div className="col-12"><h5 className="mb-3">Section Four: Our Services</h5></div>
                                    {[
                                        { name: 'section_four_heading', label: 'Heading' },
                                        { name: 'section_four_sub_heading', label: 'Sub Heading' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-6 col-md-6" key={name}>
                                            <label className="form-label">{label}</label>
                                            <input type="text" className="form-control" name={name} value={formData[name]} onChange={handleChange} />
                                        </div>
                                    ))}
                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Image</label>
                                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e, 'section_four_background_img')} />
                                        {imagePreviews.section_four_background_img && (
                                            <img src={imagePreviews.section_four_background_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 5 */}
                                    <div className="col-12"><h5 className="mb-3">Section Five: Testimonials</h5></div>
                                    {[
                                        { name: 'section_five_heading', label: 'Heading' },
                                        { name: 'section_five_sub_heading', label: 'Sub Heading' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-6 col-md-6" key={name}>
                                            <label className="form-label">{label}</label>
                                            <input type="text" className="form-control" name={name} value={formData[name]} onChange={handleChange} />
                                        </div>
                                    ))}
                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Image</label>
                                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e, 'section_five_background_img')} />
                                        {imagePreviews.section_five_background_img && (
                                            <img src={imagePreviews.section_five_background_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Banner Image</label>
                                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e, 'section_five_banner_img')} />
                                        {imagePreviews.section_five_banner_img && (
                                            <img src={imagePreviews.section_five_banner_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-bold">Testimonials Repeater</label>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Key (Name)</th>
                                                        <th>Value (Review)</th>
                                                        <th width="10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sectionFiveRepeater.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.key} onChange={(e) => handleRepeaterChange(setSectionFiveRepeater)(index, 'key', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.value} onChange={(e) => handleRepeaterChange(setSectionFiveRepeater)(index, 'value', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <button type="button" className="btn btn-sm btn-danger px-3 py-1" onClick={() => handleRemoveRepeater(setSectionFiveRepeater)(index)}><i className="fa fa-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <button type="button" className="btn btn-sm btn-light" onClick={handleAddRepeater(setSectionFiveRepeater, { key: '', value: '' })}><i className="fa fa-plus"></i> Add Testimonial</button>
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 6 */}
                                    <div className="col-12"><h5 className="mb-3">Section Six: Get the Best Deal</h5></div>
                                    {[
                                        { name: 'section_six_heading', label: 'Heading' },
                                        { name: 'section_six_sub_heading', label: 'Sub Heading' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-6 col-md-6" key={name}>
                                            <label className="form-label">{label}</label>
                                            <input type="text" className="form-control" name={name} value={formData[name]} onChange={handleChange} />
                                        </div>
                                    ))}

                                    <div className="mb-3 col-12">
                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                            <label className="form-label mb-0">Paragraph</label>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => toggleRawMode('section_six_paragraph')}
                                            >
                                                {rawMode['section_six_paragraph'] ? '⬅ Rich Editor' : '</> Raw HTML'}
                                            </button>
                                        </div>
                                        {rawMode['section_six_paragraph'] ? (
                                            <textarea
                                                className="form-control font-monospace"
                                                rows={8}
                                                value={formData.section_six_paragraph}
                                                onChange={e =>
                                                    setFormData(prev => ({ ...prev, section_six_paragraph: e.target.value }))
                                                }
                                            />
                                        ) : (
                                            <CKEditor
                                                editor={ClassicEditor}
                                                config={{
                                                    toolbar: [
                                                        'heading', '|',
                                                        'bold', 'italic', 'link', 'code', 'codeBlock',
                                                        '|', 'bulletedList', 'numberedList'
                                                    ]
                                                }}
                                                data={formData.section_six_paragraph}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setFormData(prev => ({ ...prev, section_six_paragraph: data }));
                                                    const hiddenInput = document.querySelector('input[name="section_six_paragraph"]');
                                                    if (hiddenInput) hiddenInput.value = data;
                                                }}
                                            />
                                        )}
                                        <input
                                            type="hidden"
                                            name="section_six_paragraph"
                                            value={formData.section_six_paragraph}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Image</label>
                                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e, 'section_six_background_img')} />
                                        {imagePreviews.section_six_background_img && (
                                            <img src={imagePreviews.section_six_background_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 7 */}
                                    <div className="col-12"><h5 className="mb-3">Section Seven: How It Works</h5></div>
                                    {[
                                        { name: 'section_seven_heading', label: 'Heading' },
                                        { name: 'section_seven_sub_heading', label: 'Sub Heading' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-6 col-md-6" key={name}>
                                            <label className="form-label">{label}</label>
                                            <input type="text" className="form-control" name={name} value={formData[name]} onChange={handleChange} />
                                        </div>
                                    ))}

                                    {/* <div className="mb-3 col-12">
                                        <label className="form-label">Paragraph</label>
                                        <textarea className="form-control" name="section_seven_paragraph" value={formData.section_seven_paragraph} onChange={handleChange} rows="3"></textarea>
                                    </div> */}

                                    <div className="mb-3 col-12">
                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                            <label className="form-label mb-0">Paragraph</label>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => toggleRawMode('section_seven_paragraph')}
                                            >
                                                {rawMode['section_seven_paragraph'] ? '⬅ Rich Editor' : '</> Raw HTML'}
                                            </button>
                                        </div>
                                        {rawMode['section_seven_paragraph'] ? (
                                            <textarea
                                                className="form-control font-monospace"
                                                rows={8}
                                                value={formData.section_seven_paragraph}
                                                onChange={e =>
                                                    setFormData(prev => ({ ...prev, section_seven_paragraph: e.target.value }))
                                                }
                                            />
                                        ) : (
                                            <CKEditor
                                                editor={ClassicEditor}
                                                config={{
                                                    toolbar: [
                                                        'heading', '|',
                                                        'bold', 'italic', 'link', 'code', 'codeBlock',
                                                        '|', 'bulletedList', 'numberedList'
                                                    ]
                                                }}
                                                data={formData.section_seven_paragraph}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setFormData(prev => ({ ...prev, section_seven_paragraph: data }));
                                                    const hiddenInput = document.querySelector('input[name="section_seven_paragraph"]');
                                                    if (hiddenInput) hiddenInput.value = data;
                                                }}
                                            />
                                        )}
                                        <input
                                            type="hidden"
                                            name="section_seven_paragraph"
                                            value={formData.section_seven_paragraph}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Image</label>
                                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e, 'section_seven_background_img')} />
                                        {imagePreviews.section_seven_background_img && (
                                            <img src={imagePreviews.section_seven_background_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-bold">Steps Repeater</label>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Key (Title)</th>
                                                        <th>Value (Description)</th>
                                                        <th>Icon</th>
                                                        <th width="10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sectionSevenRepeater.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.key} onChange={(e) => handleRepeaterChange(setSectionSevenRepeater)(index, 'key', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.value} onChange={(e) => handleRepeaterChange(setSectionSevenRepeater)(index, 'value', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.icon || ''} onChange={(e) => handleRepeaterChange(setSectionSevenRepeater)(index, 'icon', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <button type="button" className="btn btn-sm btn-danger px-3 py-1" onClick={() => handleRemoveRepeater(setSectionSevenRepeater)(index)}><i className="fa fa-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <button type="button" className="btn btn-sm btn-light" onClick={handleAddRepeater(setSectionSevenRepeater, { key: '', value: '', icon: '' })}><i className="fa fa-plus"></i> Add Step</button>
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 8 */}
                                    <div className="col-12"><h5 className="mb-3">Section Eight: Features</h5></div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label fw-bold">Features Repeater</label>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Icon</th>
                                                        <th>Value</th>
                                                        <th width="10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sectionEightRepeater.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.icon || ''} onChange={(e) => handleRepeaterChange(setSectionEightRepeater)(index, 'icon', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control form-control-sm" value={item.value} onChange={(e) => handleRepeaterChange(setSectionEightRepeater)(index, 'value', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <button type="button" className="btn btn-sm btn-danger px-3 py-1" onClick={() => handleRemoveRepeater(setSectionEightRepeater)(index)}><i className="fa fa-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <button type="button" className="btn btn-sm btn-light" onClick={handleAddRepeater(setSectionEightRepeater, { icon: '', value: '' })}><i className="fa fa-plus"></i> Add Feature</button>
                                    </div>

                                    <hr className="my-4" />

                                    {/* Section 9 */}
                                    <div className="col-12"><h5 className="mb-3">Section Nine: Ready to Find</h5></div>
                                    {[
                                        { name: 'section_nine_heading', label: 'Heading' },
                                        { name: 'section_nine_sub_heading', label: 'Sub Heading' },
                                        { name: 'section_nine_cta_text', label: 'CTA Text' },
                                        { name: 'section_nine_cta_link', label: 'CTA Link' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-3 col-md-6" key={name}>
                                            <label className="form-label">{label}</label>
                                            <input type="text" className="form-control" name={name} value={formData[name]} onChange={handleChange} />
                                        </div>
                                    ))}
                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Image</label>
                                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(e, 'section_nine_background_img')} />
                                        {imagePreviews.section_nine_background_img && (
                                            <img src={imagePreviews.section_nine_background_img} alt="Preview" width={200} className="mt-2 rounded" />
                                        )}
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label className="form-label">Background Video <small className="text-muted">(.mp4)</small></label>
                                        <input type="file" className="form-control" accept="video/mp4" onChange={(e) => handleImageChange(e, 'section_nine_background_video')} />
                                        {imagePreviews.section_nine_background_video && (
                                            <video src={imagePreviews.section_nine_background_video} width={300} className="mt-2 rounded" controls />
                                        )}
                                    </div>

                                </div>
                                <div className="pt-3">
                                    <button type="button" className="btn btn-sm btn-primary me-2" onClick={handleFormSubmit} disabled={submitting}>
                                        {submitting ? <><i className="spinner-border spinner-border-sm me-1"></i>Saving...</> : <><i className="fa fa-floppy-disk me-2"></i>Save</>}
                                    </button>
                                    <Link to={ROUTES.ROOT} className="btn btn-sm btn-danger light">
                                        <i className="fas fa-times-circle"></i>&nbsp;
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomeCMS;
